import { MijnRoute } from '../../mijn-navigatie.model';

export const INVESTMENT_CASH: MijnRoute = {
    path: ':id/gelddeel',
    navigationEvent: 'toCash',
    regex: /^\/beleggen\/[^/]+\/gelddeel$/,
    webcomponent: 'mijn-beleggen-portfolio-webcomponent',
    internalPath: ':id/gelddeel'
};
